import Vue from "vue";
import Router from "vue-router";
import admin from "./admin";
import user from "./user";
import API from "@/api";

Vue.use(Router);

const router = new Router({
  linkExactActiveClass: "active",
  scrollBehavior: () => ({
    y: 0,
  }),
  mode: "history",
  routes: [...admin, ...user],
});

export default router;
router.beforeEach((to, from, next) => {
  if (to.path.split("/")[1] == "AdminSystem") {
    let email = localStorage.getItem("email");
    let password = localStorage.getItem("password");
    document.title = to.meta?.title ?? "default title";
    if (
      email !== null &&
      password !== null &&
      localStorage.getItem("isLoggedin") === null
    ) {
      let data = {
        email: email,
        password: password,
      };

      API.login(
        data,
        (data) => {
          if (typeof data.token !== "undefined") {
            localStorage.setItem("isLoggedin", data.token);
            localStorage.setItem(
              "userPermissions",
              JSON.stringify(data.permission)
            );
            Vue.prototype.$session.set("isLoggedin", data.token);
            Vue.prototype.$session.set(
              "userPermissions",
              JSON.stringify(data.permission)
            );
            if (to.name === "") {
              next({ name: "dashboard" });
            } else {
              next({
                name: to.name,
              });
            }
          }
        },
        (err) => { }
      );
    } else {
      if (
        next.name === "forget-password" &&
        to.name !== "reset-password" &&
        localStorage.getItem("isLoggedin") === null
      ) {
        next({
          name: "forget-password",
        });
      } else if (
        to.name !== "login" &&
        to.name !== "forget-password" &&
        to.name !== "reset-password" &&
        localStorage.getItem("isLoggedin") === null
      ) {
        next({
          name: "login",
        });
      } else if (
        to.name === "login" &&
        localStorage.getItem("isLoggedin") !== null
      ) {
        next({ name: "dashboard" });
      } else {
        next();
      }
    }
  } else if (to.path.split("/")[1] == "dashboard") {
    document.title = to.meta?.title ?? "default title";
    let userDetails = JSON.parse(localStorage.getItem('userDetails'));
    let userToken = localStorage.getItem("userLoginToken");
    if (to.name == "user_login" && userToken != null) {
      next({ name: "user_dashboard" });
    } else if (to.name == "user_dashboard" && userToken == null) {
      next({ name: "user_login" });
    } else if (to.name != "user_login" && userToken == null) {
      next({ name: "user_login" });
    } else {
      next();
    }
  } else {
    next();
  }
});
